export const MaintenanceRenewalPageTemplate = {
    slots: ['SlbMaintenanceRenewalContainerSlot'],
};